import React from 'react';
import { NavHashLink as NavLink } from 'react-router-hash-link';
import { connect } from 'react-redux';
import './TabLink.scss';
import IconChevronDownBlack16px from '../../assets/Icon_Chevron-Down_Black-16px.svg';
import { withRouter } from "react-router-dom";

const TabLink = React.memo(props => {
    const search = props.location?.search || '';
    const finalTo = props.to.includes('?') ? props.to : `${props.to}${search}`;


    return(
        <NavLink
            activeClassName={"active"}
            className={`co-tab-link ${props.className ? props.className : ""}`}
            exact={props.exact}
            to={finalTo}
            location={{ pathname: props.pathname }}
            smooth={true}
            scroll={(e) => window.scrollTo({ left: 0, top: e.offsetTop - 176, behavior: 'smooth' })}>
            <span className={`co-tab-link_text`}>{props.text}</span>
            <img className={"co-tab-link_img-mobile"} src={IconChevronDownBlack16px} alt={""} />
        </NavLink>
    )
}

);


export default withRouter(connect(
    state => ({
        pathname: state.router.location.pathname + state.router.location.hash,
    })
)(TabLink));
